import React, { useEffect, useState } from "react";
import ProductImage from "./ProductImage";
import {
  FetchAllCategoryApi,
  FetchAllSellers,
  FetchSubcategoriesApi,
} from "../../ApiCalls/AddProducts";
// import { SellerBrandFetchApi } from "../../ApiCalls/Brands";
import { BrandsFetchApi, SellerBrandsFetchApi } from "../../ApiCalls/Seller";
import { useAuth } from "../../context/AuthContext";
import { BASE_URL, USER_URL } from "../../constant/api";
import axios from "axios";

const ProductForm = ({
  productData,
  handleChange,
  handleImageChange,
  handleSubmit,
  sellers,
  handleRemoveImage,
}) => {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [units, setUnits] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const { user } = useAuth();
  const categoryFetch = async () => {
    try {
      const response = await FetchAllCategoryApi();
      setCategories(response?.Data || []);
      console.log("Categories:", response.Data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const subcategoryFetch = async (categoryId) => {
    try {
      const response = await FetchSubcategoriesApi(categoryId); // Fetch subcategories by category ID
      setSubcategories(response?.Data || []);
      console.log("Subcategories:", response.Data);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const brandFetch = async () => {
    try {
      const response = await BrandsFetchApi();
      setBrands(response?.Data || []);
      console.log("Brands:", response);
    } catch (error) {
      console.error("Error fetching brands:", error);
    }
  };
 const fetchUnits = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/products/unit/`);
      console.log("Units fetched:", response.data.data);

      setUnits(response.data.data);
    } catch (error) {
      console.error("Error fetching units:", error);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/products/currency/`);
      console.log("Currencies fetched:", response.data.data);
      setCurrencies(response.data.data);
    } catch (error) {
      console.error("Error fetching currencies:", error);
    }
  };

  
  useEffect(() => {
    categoryFetch();
    brandFetch();
    fetchUnits();
    fetchCurrencies();
    // subcategoryFetch(productData?.category)
  }, []);
  useEffect(() => {
    if (productData.category) {
      subcategoryFetch(productData.category);
    }
  }, [productData.category]);

  const handleCategoryChange = (e) => {
    const { value } = e.target;
    handleChange(e); // Update parent component state
    if (value) {
      const sub = subcategoryFetch(value); // Fetch subcategories for selected category
    } else {
      setSubcategories([]); // Clear subcategories if no category is selected
    }
  };
  const calculateDiscountedPrice = () => {
    const price = parseFloat(productData.actual_price) || 0;
    const discount = parseFloat(productData.offer_percent) || 0;
    return price - (price * discount) / 100;
  };

  return (
    <div className="flex h-full w-full flex-col justify-center md:flex-row">
      <div className="flex w-full flex-col gap-1 md:w-1/2 md:px-10">
        <div className="mb-1 flex flex-col gap-1">
          <label className="mb-1 block text-brand-text-light">
            Product Name
          </label>
          <input
            type="text"
            name="name"
            placeholder="Product name"
            value={productData.name || ""}
            onChange={handleChange}
            className="w-full rounded border bg-slate-100 p-2"
            required
          />
        </div>
        <div className="mb-1 flex flex-col gap-1">
          <label className="mb-1 block text-brand-text-light">
            Product Code
          </label>
          <input
            type="text"
            name="product_code"
            placeholder="Product Code"
            value={productData.product_code || ""}
            onChange={handleChange}
            className="w-full rounded border bg-slate-100 p-2"
            required
          />
        </div>

        <div className="mb-1 flex flex-col gap-1">
          <label className="mb-1 block text-brand-text-light">
            Description
          </label>
          <textarea
            name="description"
            placeholder="Product Description"
            value={productData.description || ""}
            onChange={handleChange}
            className="w-full rounded border bg-slate-100 p-2"
            required
          />
        </div>

        <div className="mb-1 justify-between flex gap-1">
          <div>
            <label className="mb-1 block text-brand-text-light">
              Currency 
            </label>

            <select
              name="currency"
              value={productData.currency || ""}
              onChange={handleChange}
              className="rounded border bg-slate-100 p-2"
              required
            >
              <option value="" disabled>
                -- Select Currency --
              </option>
              {currencies.map((cur, index) => (
                <option key={index} value={cur.id}>
                  {cur.name} ({cur.symbol})
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="mb-1 block text-brand-text-light">Price</label>
            <input
              type="number"
              name="actual_price"
              placeholder="Price"
              value={productData.actual_price || ""}
              onChange={handleChange}
              className="w-full rounded border bg-slate-100 p-2"
              required
            />
          </div>
        </div>
        <div className="mb-1 flex flex-col gap-1">
          <label className="mb-1 block text-brand-text-light">Category</label>
          <select
            name="category"
            value={productData.category || ""}
            onChange={handleCategoryChange}
            className="w-full rounded border bg-slate-100 p-2"
            required
          >
            <option value="" disabled>
              Select a category
            </option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-1 flex flex-col gap-1">
          <label className="mb-1 block text-brand-text-light">
            Sub Category
          </label>
          <select
            name="subcategory"
            value={productData.subcategory || ""}
            onChange={handleChange}
            className="w-full rounded border bg-slate-100 p-2"
            required
          >
            <option value="" disabled>
              Select a subcategory
            </option>
            {subcategories.map((subcategory) => (
              <option key={subcategory.id} value={subcategory.id}>
                {subcategory.name}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-1 flex flex-col justify-between md:flex-row">
          <div className="md:w-2/5">
            <label className="mb-1 block text-brand-text-light">
              Product Offer{" "}
            </label>
            <input
              type="number"
              name="offer_percent"
              placeholder="Offer Percent"
              value={productData.offer_percent || ""}
              onChange={handleChange}
              className="w-full rounded border bg-slate-100 p-2"
              required
            />
          </div>
          <div className="md:w-2/5">
            <label className="mb-1 block text-brand-text-light">
              Price after Offer{" "}
            </label>
            <div className="w-full rounded border bg-slate-100 p-2">
              {calculateDiscountedPrice() || "0.00"}
            </div>
          </div>
        </div>
        <div className="mb-1 flex flex-col gap-1">
          <label className="mb-1 block text-brand-text-light">
            Transportation Fee
          </label>
          <input
            type="number"
            name="delivery_charge"
            placeholder="Delivery Charge"
            value={productData.delivery_charge || ""}
            onChange={handleChange}
            className="w-full rounded border bg-slate-100 p-2"
            required
          />
        </div>
      </div>
      <div className="flex w-full flex-col gap-2 md:w-1/2 md:px-10">
        <div className="mb-1 flex flex-col gap-1">
          <label className="mb-1 block text-brand-text-light">
            Select Unit
          </label>
          <select
            name="unit"
            value={productData.unit || ""}
            onChange={handleChange}
            className="w-full rounded border bg-slate-100 p-2"
            required
          >
            <option value="" disabled>
              -- Select Unit --
            </option>
              {units.map((unit, index) => (
                <option key={index} value={unit.id}>
                  {unit.name} ({unit.short_code})
                </option>
              ))}
          </select>
        </div>
        <div className="mb-1 flex flex-col gap-1">
          <label className="mb-1 block text-brand-text-light">
            Add Minimum Order Quantities
          </label>
          <div className="flex flex-wrap gap-2">
            <div className="mb-1 flex">
              <input
                type="number"
                name="min_order_quantity"
                placeholder="50"
                value={productData.min_order_quantity || ""}
                onChange={handleChange}
                className="w-24 rounded border bg-slate-100 p-2"
              />
            </div>
            <div className="mb-1 flex">
              <input
                type="number"
                name="min_order_quantity_two"
                placeholder="100"
                value={productData.min_order_quantity_two || ""}
                onChange={handleChange}
                className="w-24 rounded border bg-slate-100 p-2"
              />
            </div>
            <div className="mb-1 flex">
              <input
                type="number"
                name="min_order_quantity_three"
                placeholder="150"
                value={productData.min_order_quantity_three || ""}
                onChange={handleChange}
                className="w-24 rounded border bg-slate-100 p-2"
              />
            </div>
            <div className="mb-1 flex">
              <input
                type="number"
                name="min_order_quantity_four"
                placeholder="200"
                value={productData.min_order_quantity_four || ""}
                onChange={handleChange}
                className="w-24 rounded border bg-slate-100 p-2"
              />
            </div>
            <div className="mb-1 flex">
              <input
                type="number"
                name="min_order_quantity_five"
                placeholder="250"
                value={productData.min_order_quantity_five || ""}
                onChange={handleChange}
                className="w-24 rounded border bg-slate-100 p-2"
              />
            </div>
          </div>
        </div>
        {user?.user_type === "admin" && (
          <div className="mb-1 flex flex-col gap-1">
            <label className="mb-1 block text-brand-text-light">Seller</label>
            <select
              name="vendor"
              value={productData.vendor || ""}
              onChange={handleChange}
              className="w-full rounded border bg-slate-100 p-2"
              required
            >
              <option value="" disabled>
                Select Seller
              </option>
              {sellers.map((seller) => (
                <option key={seller.seller_id} value={seller.seller_id}>
                  {seller.company_name}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="mb-1 flex flex-col gap-1">
          <label className="mb-1 block text-brand-text-light">Brand</label>
          <select
            name="brand"
            value={productData.brand || ""}
            onChange={handleChange}
            className="w-full rounded border bg-slate-100 p-2"
            required
          >
            <option value="" disabled>
              Select a brand
            </option>
            {brands.map((brand) => (
              <option key={brand.id} value={brand.id}>
                {brand.name}
              </option>
            ))}
          </select>
        </div>
        <div className="mb-1 flex flex-col gap-1">
          <label className="mb-1 block text-brand-text-light">Stock</label>
          <input
            type="number"
            name="stock"
            placeholder="Stock"
            value={productData.stock || ""}
            onChange={handleChange}
            className="w-full rounded border bg-slate-100 p-2"
            required
          />
        </div>
        <div className="flex-1">
          <ProductImage
            product_images={productData.product_images}
            handleImageChange={handleImageChange}
            handleSubmit={handleSubmit}
            newProduct={true}
            handleRemoveImage={handleRemoveImage}
            productId={productData.id}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductForm;
